/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Defaultdescription1Inputs */

const he_seo_defaultdescription1 = /** @type {(inputs: Seo_Defaultdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עקבו אחרי מחירים של מוצרי KSP, השוו היסטוריית מחירים ומצאו את העסקאות הטובות ביותר.`)
};

const en_seo_defaultdescription1 = /** @type {(inputs: Seo_Defaultdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track KSP product prices, compare price history and find the best deals with Pricedrop.`)
};

/**
* | output |
* | --- |
* | "Track KSP product prices, compare price history and find the best deals with Pricedrop." |
*
* @param {Seo_Defaultdescription1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const seo_defaultdescription1 = /** @type {((inputs?: Seo_Defaultdescription1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Defaultdescription1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_defaultdescription1(inputs)
	return en_seo_defaultdescription1(inputs)
});
export { seo_defaultdescription1 as "seo_defaultDescription" }